import { Flex, Typography } from "@sidelinesports/fan-design-system";
import { GameTimestamp } from "../../../../components";
import { useCurrentGameQuery } from "../../hooks";
import { LiveFeedSection } from "../LiveFeed";
import { Menu } from "../Menu";
import { GameTitle } from "./GameTitle";
import { StatusChip } from "./StatusTag";

export const PageHeader = () => {
  const gameQuery = useCurrentGameQuery();
  const game = gameQuery.data;

  if (!game) {
    return null;
  }

  return (
    <Flex gap={16} align="center" justify="between">
      <Menu game={game} />
      <Flex direction="column" gap={0} w="100%">
        <GameTitle game={game} />
        <Flex gap={4} align="center">
          <Typography size="sm">
            <GameTimestamp timestamp={game.timestamp} />
          </Typography>
          <StatusChip game={game} />
        </Flex>
      </Flex>
      <LiveFeedSection />
    </Flex>
  );
};
